import { render, staticRenderFns } from "./email_input.vue?vue&type=template&id=3d56ca1e&"
import script from "./email_input.vue?vue&type=script&lang=js&"
export * from "./email_input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports